var map = {
	"./config.js": 5689,
	"./config.localhost": 2827,
	"./config.localhost.js": 2827,
	"./config.production": 9751,
	"./config.production.js": 9751,
	"./config.staging": 1863,
	"./config.staging.js": 1863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4193;